import { environment } from './../../../../../../environment/environment';
import { RateService } from './../../../../../core/services/RateService/RateService.service';
import { Component, TemplateRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { serverError } from './../../../../../core/models/messages';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-list-reviews',
  templateUrl: './list-reviews.component.html',
  styleUrls: ['./list-reviews.component.css'],
})
export class ListReviewsComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  typesCompany = [
    { name: 'Candidat', id: 1 },
    { name: 'Entreprise', id: 2 },
  ];
  /* string */
  mode: string = 'create';
  url: string = environment.baseUrl + '/api/Company/file/gallery_company/';
  urlUser: string = environment.baseUrl + '/api/User/file/gallery_users/';
  /* numbers */
  itemsPerPage: number = 5
 currentPage: number = 0
 pageSize = 5;
 pageSizeOptions = [5, 10, 20];
 itemsPerPage1: number = 5
 currentPage1: number = 0
 pageSize1 = 5;
 itemsPerPage2: number = 5
 currentPage2: number = 0
 pageSize2 = 5;
 itemsPerPage3: number = 5
 currentPage3: number = 0
 pageSize3 = 5;
 isLoadSpinner: boolean = true;


 totalItems!: number
 totalItems1!: number
 totalItems2!: number
 totalItems3!: number

 startIndex1:number=0
 endIndex1:number=5
 review:any;
 startIndex2:number=0
 endIndex2:number=5

 startIndex3:number=0
 endIndex3:number=5

startIndex:number=0
endIndex:number=5
  idQuestion!: number | undefined;
  idCompany: number = 1;
  max: number = 5;
  value: number = 3;
  totalComments!: number;
  /* array */
  listComments: any = [];
  /*any */
  data: any;
  listQuestion: any;
  listCandidatReview: any;
  listCandidatReviewDetails: any;
  listCandidatReviewByCandidat:any
  listCandidatReviewByCompany:any
  listQuestionCompany:any[]=[]
  listQuestionCandidat:any[]=[];
  pagination : boolean =false;

  // editor text
  editorContent: string = '<p>Hello World!</p>';
  /* modal */
  modalRef?: BsModalRef;
  /* subscriprion */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private rateService: RateService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private modalService: BsModalService
  ) {}
  /* init */
  ngOnInit() {
  
    this.getListQuestionCandidat()
    this.getuserReviewCandidat()
  }

  /* get indexes for pagination */
  onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex;
      this.getListQuestionCandidat()
  }
  onPageChange1(e: PageEvent): void {
    this.pageSize1 = e.pageSize;
    this.currentPage1 = e.pageIndex;
      this.getListQuestionCompany()
  }
  onPageChange2(e: PageEvent): void {
    this.pageSize2 = e.pageSize;
    this.currentPage2 = e.pageIndex;
      this.getuserReviewCandidat()
  }
  getItems3(event?: any) {
    if (event && event.startIndex != this.startIndex3 || this.endIndex3 != event.endIndex ||
      this.itemsPerPage3 != event.itemsPerPage ||
      this.currentPage3 != event.currentPage) {
      this.startIndex3 = event.startIndex
      this.endIndex3 = event.endIndex
      this.itemsPerPage3 = event.itemsPerPage,
      this.currentPage3 = event.currentPage
       this.getuserReviewCompany()
    }
  }
  onPageChange3(e: PageEvent): void {
    this.pageSize3 = e.pageSize;
    this.currentPage3 = e.pageIndex;
      this.getuserReviewCompany()
  }
  getListQuestion() {
    this.spinner.show();
    let data = { per_page: this.pageSize, page: this.currentPage };
    this.rateService
      .getListQuestion(this.idCompany, data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.spinner.hide();
            this.data = res;
            this.totalItems = res.data.total;
            this.listQuestion = res?.data?.data;
            this.getListQuestion();
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }


  getListQuestionCandidat() {
    this.spinner.show()
    let data = {per_page: this.pageSize, page: this.currentPage}
    this.rateService.getListQuestioncandidat(this.idCompany,data).pipe(takeUntil(this.unsubscribeAll)).subscribe({
      next: (res) => {
        if (res.status == 200) {
          this.isLoadSpinner = false;
          this.spinner.hide()
          this.data=res
          console.log("data",res.data)
          this.totalItems = res.data.total
          this.listQuestionCandidat = res?.data?.data
          console.log("list question candidat", this.listQuestionCandidat)
          if(this.currentPage>0 && !res.data.data.length){
            this.getListQuestionCandidat()
          } 
        }
      },
      error: () => {
        this.spinner.hide()
        this.toastr.error(serverError)
      }
    })
  }
  
  getListQuestionCompany() {
    this.spinner.show()
    let data = {per_page: this.pageSize1, page: this.currentPage1}
    this.rateService.getListQuestioncompany(this.idCompany,data).pipe(takeUntil(this.unsubscribeAll)).subscribe({
      next: (res) => {
        if (res.status == 200) {
          this.spinner.hide()
          this.data=res
          this.totalItems1 = res.data.total
          this.listQuestionCompany = res?.data?.data
          console.log("list question company", this.listQuestionCompany)
          if(this.currentPage1>0 && !res.data.data.length){
          
            this.getListQuestionCompany()
          } 
        }
      },
      error: () => {
        this.spinner.hide()
        this.toastr.error(serverError)
      }
    })
  }
  
  getuserReviewCandidat() {
    this.spinner.show();
    let data = { per_page: this.pageSize2, page: this.currentPage2 };
    this.rateService.getListusersReviewCandidat(this.idCompany, data).pipe(takeUntil(this.unsubscribeAll)).subscribe({
      next: (res) => {
        if (res.status == 200) {
          this.spinner.hide();
          console.log("response", res);
          this.totalItems2 = res.data.total;
          this.listCandidatReviewByCandidat = res.data?.data
          console.log('res.data.current_page',this.currentPage2)
          if (res.data.current_page > 0) {
            // this.currentPage1=1
            // Convertir la deuxième data de la réponse en tableau JSON
            let secondData = Object.values(res.data.data);
            this.listCandidatReviewByCandidat = secondData;
            console.log("list after update candidat", this.listCandidatReviewByCandidat);
          }
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error(serverError);
      }
    });
  }
  getuserReviewCompany() {
    this.spinner.show();
    let data = { per_page: this.pageSize3, page: this.currentPage3 };
    console.log("data",data)
    this.rateService.getListusersReviewCompany(this.idCompany, data).pipe(takeUntil(this.unsubscribeAll)).subscribe({
      next: (res) => {
        console.log("responseeeee",res)
        if (res.status == 200) {
          this.spinner.hide();
          console.log("response", res);
          this.totalItems3 = res.data.total;
          this.listCandidatReviewByCompany = res.data.data
          console.log("listCandidatReview by company", this.listCandidatReviewByCompany);
          console.log("length listCandidatReview", this.listCandidatReviewByCompany.length);
          console.log("total", res.data.total);
          if (res.data.current_page > 0) {
            // this.currentPage1=1
            // Convertir la deuxième data de la réponse en tableau JSON
          let secondData = Object.values(res.data.data);
          this.listCandidatReviewByCompany = secondData;
            console.log("list after update company", this.listCandidatReviewByCompany);
          }
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error(serverError);
      }
    });
  }



  getCandidatReview() {
    this.spinner.show();
    let data = { per_page: this.itemsPerPage, page: this.currentPage };
    this.rateService
      .getListCandidatReview(this.idCompany, data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.spinner.hide();
            this.listCandidatReview = res.data.data.reverse();
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }

  detailsReviewNavigation(id: any, type: any) {
    this.router.navigate([
      '/parametres/detail-avis-wegestu',
      { type: type, idDonneur: id },
    ]);
  }

  changeTab2(index:number){
    this.idCompany=index
    this.pageSize = 5
    this.currentPage1 = 0
    this.pageSize= 5
    this.currentPage3= 0
    this.getListQuestionCompany()
    this.getuserReviewCompany()
  }
  
  changeTab1(index:number){
    this.idCompany=index
    this.pageSize= 5
    this.currentPage= 0
    this.pageSize2= 5
    this.currentPage2= 0
     this.getListQuestionCandidat()
     this.getuserReviewCandidat()
  }
  showComments() {
    this.router.navigate([
      '/parametres/evaluation-wegestu',
      { id: this.idCompany },
    ]);
  }

  getCandidatReviewDetails(idDonneur?: any) {
    this.spinner.show();
    let data = { per_page: this.itemsPerPage, page: this.currentPage };
    this.rateService
      .getCandidatReviewById(this.idCompany, idDonneur, data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.spinner.hide();
            this.listCandidatReviewDetails = res;
            console.log("listCandidatReviewDetails",this.listCandidatReviewDetails)
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }
  openModalDetails(template: TemplateRef<any>, idDonneur: any,review:any) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    console.log('idDonneur', idDonneur);
    this.review=review
    this.getCandidatReviewDetails(idDonneur);
  }

  closeModalDetails() {
    this.modalRef!.hide();
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  navigatToDetailsCompany(id: any) {
    this.router.navigate(['/entreprises/details-entreprise/{id}', { id: id }]);
  }

  onRightClick(event: MouseEvent) {
    event.preventDefault(); // Empêche le menu contextuel par défaut
  }
}
